import {IconButton, Tooltip} from '@material-ui/core';
import {DeleteOutlined} from '@material-ui/icons';
import React, {useState} from 'react';
import {withField} from '../../FrameWorks/DataManager/DataManagerRecord/AddDataManagerRecord/RecordFormatFieldsComponents/withField';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../components/PageLoader';
// import {useDispatch} from 'react-redux';

function CompaniesTable(props) {
  const {value: current, setFieldValue, key, values, deleteRef} = props;
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const dispatch = useDispatch();
  const handleClose = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () => {
    setIsLoading(true);

    if (values?.fields?.length < 0) {
      setFieldValue('isAll', false);
    }
    if (current?.clientBillingId) {
      deleteRef?.current?.push(current?.clientBillingId);
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        setIsLoading(false);
        resolve();
        const data = [...values.fields]?.filter((i) => i.companyName !== current?.companyName);
        setFieldValue('fields', data);
        handleClose();
      }, 1000);
    });
  };
  return (
    <>
      <tr key={key}>
        {!values?.isAll && (
          <td className="recFormat-col recFormat-center new-standard-textfields ">
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setIsDelete(true);
                }}
              >
                <DeleteOutlined />
              </IconButton>
            </Tooltip>
          </td>
        )}
        <td className="recFormat-col global-field-textfields ">
          {current?.companyName?.companyName}
        </td>

        <td className="recFormat-col global-field-textfields">
          {current?.corporateName?.corporateName ? current?.corporateName?.corporateName : 'All'}
        </td>
        <td className="recFormat-col global-field-textfields">
          {current?.siteName?.siteName ? current?.siteName?.siteName : 'All'}
        </td>
        <td className="recFormat-col global-field-textfields">
          {current?.serviceClient?.serviceClientName ?
            current?.serviceClient?.serviceClientName :
            'All'}
        </td>
      </tr>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Field"
        value={`Are you sure you want to delete this field?`}
        handleSubmit={handleConfirmDelete}
      />
      {isLoading && <PageLoader />}
    </>
  );
}
export default withField(CompaniesTable);
